import Layout from "../../components/shared/layout/layout";
import styles from "../../styles/pages/weingut/index.module.css"
import {useEffect} from "react";
import Link from "next/link";
import Seo from "../../components/shared/seo/seo";

export default function Weingut(){

    useEffect(() =>{
        initSlider();
    }, [])
    return(
        <Layout>
            <Seo title="Weingut" description="Weingut Johann Gisperg — Geschichte, Sortiment, Werte und Nachhaltigkeit." path="/weingut" />
            <section className="background_light_texture no_fill">
                <div className="col-6">
                    <h1 className="white">Weingut</h1>
                    <p className="brown robertson subtitle">Gisperg</p>
                    <p>Die Burgunderfamilie – zwei Worte, die sowohl uns als auch unsere Leidenschaft perfekt beschreiben. Laurent & Co, aber auch der davon abstammende Zweigelt widerspiegeln die Kalkschotterböden unserer Heimat vollendet mit einem sortentypischen Charakter und strahlender Frucht.
                        <br/><br/>
                        Schwarz-weiß denken liegt uns fern, weshalb wir verschiedene Bewirtschaftungsweisen verbinden und niemals nach Rezept arbeiten. Nachhaltigkeit umfasst in unserem Wortschatz nicht nur dessen ökologischen Aspekt, sondern das gesamte Weingut und die mit ihm verbundenen Menschen.  </p>
                </div>
                <div className="col-12">
                    <div className="horizontal">
                        <div className="col-3">
                            <Link href="#familie"><p className="white annotation marker link">Familie</p></Link>
                        </div>
                        <div className="col-3">
                            <Link href="#werte"><p className="white annotation marker narrow link">Werte & Philosophie</p></Link>
                        </div>
                        <div className="col-3">
                            <Link href="#weingarten"><p className="white annotation marker narrow link">Weingarten & Keller</p></Link>
                        </div>
                    </div>
                    <div className="horizontal" style={{marginTop:"-20px"}}>
                        <div className="col-3">
                            <Link href="#sortiment"><p className="white annotation marker link">Sortiment</p></Link>
                        </div>
                        <div className="col-3">
                            <Link href="#nachhaltigkeit"><p className="white annotation marker link">Nachhaltigkeit</p></Link>
                        </div>
                        <div className="col-3">
                            <Link href="#geschichte"><p className="white annotation marker link">Geschichte</p></Link>
                        </div>
                    </div>
                </div>
            </section>
            <section className="background_light">
                <span  className="anchor" id="familie" ></span>
                <div className="col-12">
                    <h2>Familie</h2>
                    <div className="horizontal mobile">
                        <div className={`${styles.button} ${styles.left}`}><p className="marker standalone black"></p></div>
                        <div className={styles.items}>
                            <div className={`${styles.item} ${styles.active}`} id="hansi">
                                <img alt=""  src="/images/familie/hansi.webp" width="396" height="396"/>
                            </div>
                            <div className={`${styles.item} ${styles.next}`} id="leonie">
                                <img alt=""  src="/images/familie/leonie.webp" width="1500" height="2000"/>
                            </div>
                            <div className={`${styles.item}`} id="hans">
                                <img alt=""  src="/images/familie/hans.webp" width="396" height="396"/>
                            </div>
                            <div className={`${styles.item}`} id="erika">
                                <img alt=""  src="/images/familie/erika.webp" width="396" height="396"/>
                            </div>
                            <div className={`${styles.item}`} id="petra">
                                <img alt=""  src="/images/familie/petra.webp" width="396" height="396"/>
                            </div>
                            <div className={`${styles.item} ${styles.prev}`} id="grosseltern">
                                <img alt=""  src="/images/familie/grosseltern.webp" width="396" height="396"/>
                            </div>
                        </div>
                        <div className={`${styles.button}`}><p className="marker standalone black"></p></div>
                    </div>
                </div>
                <div className={`col-6 ${styles.description}`} id="hansi_description" style={{display:'flex'}}>
                    <h3 style={{marginBottom:0}}>Johann Gisperg</h3>
                    <p className="robertson brown size-40" style={{marginTop:0}}>Junior</p>
                    <p className="center-text">Ein großer Wein entsteht im Kopf und im Herzen.
                        Durch die Ideen der Generationen vor uns, eine klare Vorstellung in allen Bereichen des Weingutes, Demut gegenüber der Natur und die Passion der tätigen Menschen diese auch umzusetzen, kommen besondere Weine zustande. Er entsteht nicht von selbst, jedoch steht uns im Keller nur das Weingartengegebene zu Verfügung. </p>
                </div>
                <div className={`col-6 ${styles.description}`} id="leonie_description" style={{display:'none'}}>
                    <h3 style={{marginBottom:0}}>Leonie Gisperg</h3>
                    <p className="robertson brown size-40" style={{marginTop:0}}>die Zukunft</p>
                    <p className="center-text">Ein großer Wein entsteht im Kopf und im Herzen.
                        Durch die Ideen der Generationen vor uns, eine klare Vorstellung in allen Bereichen des Weingutes, Demut gegenüber der Natur und die Passion der tätigen Menschen diese auch umzusetzen, kommen besondere Weine zustande. Er entsteht nicht von selbst, jedoch steht uns im Keller nur das Weingartengegebene zu Verfügung. </p>
                </div>
                <div className={`col-6 ${styles.description}`} id="hans_description" style={{display:'none'}}>
                    <h3 style={{marginBottom:0}}>Johann Gisperg</h3>
                    <p className="robertson brown size-40" style={{marginTop:0}}>der Mittlere</p>
                    <p className="center-text">Ein großer Wein entsteht im Kopf und im Herzen.
                        Durch die Ideen der Generationen vor uns, eine klare Vorstellung in allen Bereichen des Weingutes, Demut gegenüber der Natur und die Passion der tätigen Menschen diese auch umzusetzen, kommen besondere Weine zustande. Er entsteht nicht von selbst, jedoch steht uns im Keller nur das Weingartengegebene zu Verfügung. </p>
                </div>
                <div className={`col-6 ${styles.description}`} id="erika_description" style={{display:'none'}}>
                    <h3>Erika Gisperg</h3>
                    <p className="center-text">Ein großer Wein entsteht im Kopf und im Herzen.
                        Durch die Ideen der Generationen vor uns, eine klare Vorstellung in allen Bereichen des Weingutes, Demut gegenüber der Natur und die Passion der tätigen Menschen diese auch umzusetzen, kommen besondere Weine zustande. Er entsteht nicht von selbst, jedoch steht uns im Keller nur das Weingartengegebene zu Verfügung. </p>
                </div>
                <div className={`col-6 ${styles.description}`} id="petra_description" style={{display:'none'}}>
                    <h3>Petra Gisperg</h3>
                    <p className="center-text">Ein großer Wein entsteht im Kopf und im Herzen.
                        Durch die Ideen der Generationen vor uns, eine klare Vorstellung in allen Bereichen des Weingutes, Demut gegenüber der Natur und die Passion der tätigen Menschen diese auch umzusetzen, kommen besondere Weine zustande. Er entsteht nicht von selbst, jedoch steht uns im Keller nur das Weingartengegebene zu Verfügung. </p>
                </div>
                <div className={`col-6 ${styles.description}`} id="grosseltern_description" style={{display:'none'}}>
                    <h3 style={{marginBottom:0}}>Hedwig & Johann Gisperg</h3>
                    <p className="robertson brown size-40" style={{marginTop:0}}>Senior</p>
                    <p className="center-text">Ein großer Wein entsteht im Kopf und im Herzen.
                        Durch die Ideen der Generationen vor uns, eine klare Vorstellung in allen Bereichen des Weingutes, Demut gegenüber der Natur und die Passion der tätigen Menschen diese auch umzusetzen, kommen besondere Weine zustande. Er entsteht nicht von selbst, jedoch steht uns im Keller nur das Weingartengegebene zu Verfügung. </p>
                </div>
            </section>
            <section>
                <span  className="anchor" id="werte" ></span>
                <div className="horizontal transition_div">
                    <div className="col-4">
                        <h2 className="white">Werte & Philosophie</h2>
                    </div>
                    <div className="col-4">
                        <div className="horizontal">
                            <p style={{fontSize:"250px", alignSelf: "end"}}>&rdquo;</p>
                            <p className="white">Unsere 4 Werte sind die Himmelsrichtungen auf dem Kompass, nach welchen wir uns ausrichten und unseren Weg gehen.</p>
                        </div>
                    </div>
                    <div className="col-4">
                        <Link href="weingut/werte">
                                <p className="button secondary dark white">Entdecken</p>
                        </Link>
                    </div>
                </div>
            </section>
            <section className="background_light">
                <span  className="anchor" id="weingarten" ></span>
                <div className="horizontal">
                    <div className="col-6">
                        <img alt=""  src="/images/weingarten.webp" width="1500" height="2000"/>
                    </div>
                    <div className="col-6 left">
                        <h2>Weingarten<br/> & Keller</h2>
                        <p>Qualität entsteht im Weingarten - der Feinschliff im Weinkeller. Während bei einem 1000 Handgriffe fruchtbar sind, werden sie beim anderen gemieden. Sorgfalt, Handarbeit und Herzblut sind allerdings bei beiden essenziell. </p>
                        <Link href="/weingut/weingarten">
                            <p className="button secondary x2 uppercase">Erkunden</p>
                        </Link>
                    </div>
                </div>
            </section>
            <section className="background_light_texture">
                <span  className="anchor" id="nachhaltigkeit" ></span>
                <div className="horizontal">
                    <div className="col-6 left">
                        <h2 className="white">Nachhaltigkeit</h2>
                        <p>Seit Generationen arbeitet unsere Familie Hand in Hand mit der Natur. Deswegen ist es uns ein Anliegen dieses Gut zu bewahren, um es der nächsten Generation weitergeben zu können.  </p>
                        <Link href="/weingut/nachhaltigkeit">
                            <p className="button secondary dark x2 uppercase">Mehr erfahren</p>
                        </Link>
                    </div>
                    <div className="col-6">
                        <img alt=""  src="/images/nachhaltigkeit.webp" width="701" height="335"/>
                    </div>
                </div>
            </section>
            <section className="background_light">
                <span  className="anchor" id="sortiment" ></span>
                <div className="col-12">
                    <h2>Sortiment</h2>
                    <div className={styles.hoverContainer}>
                        <img alt=""  src="/images/shop/CHR_0,75l_Gisperg.webp" style={{zIndex:3}} className={styles.hoverLeftSecond} width="667" height="1000"/>
                        <img alt=""  src="/images/shop/WBR_0,75l_Gisperg.webp" style={{zIndex:4}} className={styles.hoverLeft} width="667" height="1000"/>
                        <img alt=""  src="/images/shop/PNR_0,75l_Gisperg.webp" style={{zIndex:5}} width="667" height="1000"/>
                        <img alt=""  src="/images/shop/SLR_0,75l_Gisperg.webp" style={{zIndex:4}} className={styles.hoverRight} width="667" height="1000"/>
                        <img alt=""  src="/images/shop/PGR_0,75l_Gisperg.webp" style={{zIndex:3}} className={styles.hoverRightSecond} width="667" height="1000"/>
                    </div>
                    <p className="center-text">Gehen Sie auf Entdeckungstour.<br/> Sie erwarten Burgunderwunder, Puristen & unsere traditionelle Vielfalt. </p>
                    <Link href="/weingut/sortiment">
                            <p className="button secondary x2 uppercase">Durchstöbern</p>
                    </Link>
                </div>
            </section>
            <section className="background_lighter">
                <span  className="anchor" id="geschichte" ></span>
                <div className="horizontal">
                    <div className="col-8">
                        <img alt=""  src="/images/geschichte.webp" width="100%"/>
                    </div>
                    <div className="col-6 left">
                        <h2>Geschichte</h2>
                        <p className="narrow">Der Grundstein für heutige Erfolge wurde von vorangegangen Generationen in unserem Haus gelegt. Tauchen Sie in die Geschichte unseres Weingutes und unserer Familie ein.
                            <br/><br/>
                            Ein Rückblick über 300 Jahre erzählt von Johann sen. und Johann jun. </p>
                        <Link href="/weingut/geschichte">
                                <p className="button secondary x2 uppercase">Mehr erfahren</p>
                        </Link>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

function initSlider(){
    const slider = document.querySelector(styles.items);
    const slides = document.getElementsByClassName(styles.item);
    const button = document.getElementsByClassName(styles.button);
    const descriptions = document.getElementsByClassName(styles.description);

    
    

    let current = 0;
    let prev = 0;
    let next = 2;

    for (let i = 0; i < button.length; i++) {
        button[i].addEventListener("click", () => i == 0 ? gotoPrev() : gotoNext());
    }

    const gotoPrev = () => current > 0 ? gotoNum(current - 1) : gotoNum(slides.length - 1);

    const gotoNext = () => current < 5 ? gotoNum(current + 1) : gotoNum(0);

    const gotoNum = number => {
        current = number;
        prev = current - 1;
        next = current + 1;

        for (let i = 0; i < slides.length; i++) {
            slides[i].classList.remove(styles.active);
            slides[i].classList.remove(styles.prev);
            slides[i].classList.remove(styles.next);
        }

        for (let i = 0; i < descriptions.length; i++) {
            descriptions[i].style.display = 'none';
        }

        if (next == 6) {
            next = 0;
        }

        if (prev == -1) {
            prev = 5;
        }

        slides[current].classList.add(styles.active);
        if(slides[current].id === "hansi"){
            document.getElementById("hansi_description").style.display = 'flex';
        }
        if(slides[current].id === "hans"){
            document.getElementById("hans_description").style.display = 'flex';
        }
        if(slides[current].id === "leonie"){
            document.getElementById("leonie_description").style.display = 'flex';
        }
        if(slides[current].id === "erika"){
            document.getElementById("erika_description").style.display = 'flex';
        }
        if(slides[current].id === "petra"){
            document.getElementById("petra_description").style.display = 'flex';
        }
        if(slides[current].id === "grosseltern"){
            document.getElementById("grosseltern_description").style.display = 'flex';
        }
        slides[prev].classList.add(styles.prev);
        slides[next].classList.add(styles.next);
    }
}